module.exports = __webpack_public_path__ + "static/img/son9_active.b6578b47.png";